<template>

  <div class="loading">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"><circle cx="50" cy="50" fill="none" stroke="#c9c8c5" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(22.343 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
  </div>

</template>

<script>
  export default {
    name: "Loading",
  }
</script>

<style lang="scss">
  .loading {
    background-color: darken(#F5F7FA, 3%);
    min-height: rem(400px);
    width: 100%;
    max-width: rem(1150px);
    margin: 0 auto rem(50px) auto;
    
    svg {
      float: left;
      margin: rem(20px);
      max-width: rem(50px);
      max-height: rem(50px);
    }
  }

  .top .loading {
    min-height: rem(145px);
    margin: 0 auto 0 auto;
  }

</style>